export const DYNAMIC_EXPIRE = 300 // 5 minutes
export const RUNTIME_PREFETCH_DYNAMIC_STALE = 30 // 30 seconds
